// extracted by mini-css-extract-plugin
export default {"root":"Ratio-module--root--0c857","landing":"Ratio-module--landing--372fc","hide":"Ratio-module--hide--d8135","default":"Ratio-module--default--1e473"};